<template>
    <div class="record-box">
        <div>
            <span class="icon-span"><font-awesome-icon icon="fa-solid fa-location-dot" /></span>&nbsp;<span>{{countryName}}</span>
        </div>

        <div>
            <span tkey="中文描述">{{i18n.tkey("lang_chinese_remark")}}:&nbsp;</span>
            <span>{{obj.ShipmentAddress}}</span>
        </div>

        <div>
            <span tkey="英文描述">{{i18n.tkey("lang_english_remark")}}:&nbsp;</span>
            <span>{{obj.ShipmentAddressCN}}</span>
        </div>

        <div class="operation-box" v-loading="loading">
            <el-button type="primary" @click="clickEditBtn"><font-awesome-icon icon="fa-solid fa-pen-to-square" /></el-button>
            <el-button type="danger" @click="clickDelBtn"><font-awesome-icon icon="fa-solid fa-trash-can" /></el-button>
        </div>
    </div>
</template>

<script setup>
    import {inject, toRef, ref, computed} from "vue";
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faTrashCan, faPenToSquare, faLocationDot } from '@fortawesome/free-solid-svg-icons'
    import {useUserinfo} from "@/stores/userinfo";
    import myUtil from "@/util/util";
    import eshopopeeApi from "@/request/eshopopeeApi";

    library.add(faTrashCan, faPenToSquare, faLocationDot)

    const props = defineProps(["obj"])
    const emits = defineEmits(["clickEditBtn", "clickDelBtn"])

    const i18n = inject("i18n")
    const loading = ref(false)

    const userInfoRef = toRef(useUserinfo())

    const countryName = computed(() => {
        let name = ""

        if (props.obj.District1 == "all"){
            name = i18n.tkey("lang_all_region")
        }else{
            if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
                name = props.obj.CountryName
            }else{
                name = props.obj.CountryName2
            }
        }

        return name
    })

    function clickEditBtn() {
        emits("clickEditBtn", props.obj)
    }

    function clickDelBtn() {
        myUtil.confirmWarning(i18n.tkey("lang_delete_confirm"), () => {
            delRecord()
        })

    }

    function delRecord() {
        loading.value = true

        const request = eshopopeeApi.delDeliverynameRecord
        const params = request.getParams()

        params.id = props.obj.ID

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                myUtil.alertSuccess(i18n.tkey("lang_delete_success"))
                emits("clickDelBtn")
            }else{
                myUtil.alertError(i18n.tkey("lang_request_error"))
            }
        })

    }

</script>

<style scoped>
    .operation-box {
        text-align: right;
        margin-top: 20px;
    }

    .icon-span {
        color: #79bbff;
    }

    .record-box {
        margin-bottom: 20px;
        border: 1px #EBEEF5 solid;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 15px;
        text-align: left;
        line-height: 2;
    }
</style>